import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SidebarV2, TopbarV2 } from './components';

const Main = ({ children, modeSetting, resolvedMode, onModeSettingChange }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuClose = useCallback(() => {
    setOpenMenu(false);
  }, []);

  const handleMenuClick = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <SidebarV2
        isDesktop={isMdUp}
        openMenu={openMenu}
        onMenuClose={handleMenuClose}
      />

      <Box sx={{ flex: 1, minWidth: 0, backgroundColor: 'background.default' }}>
        <TopbarV2
          onMenuClick={handleMenuClick}
          modeSetting={modeSetting}
          resolvedMode={resolvedMode}
          onModeSettingChange={onModeSettingChange}
        />

        <Box sx={{ p: 3, mt: 8 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  modeSetting: PropTypes.oneOf(['system', 'light', 'dark']).isRequired,
  resolvedMode: PropTypes.oneOf(['light', 'dark']).isRequired,
  onModeSettingChange: PropTypes.func.isRequired,
};

export default Main;
